module.exports = __webpack_public_path__ + "img/wind.cbfa811e.svg";